import { useEffect, useState } from 'react'
import { Stack, Typography } from '@mui/material'
import {
  IContract,
  IContractsGroup,
} from '~/@api/generated-api-types/global.types'
import { getApi } from '~/@utils/api/getApi'
import { useAlert } from '~/@ui/alert/useAlert'
import { Document } from '~/@ui/document/Document'
import ArrowSvg from '~/@ui/_sharedSvgs/ui/Arrow.svg?react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import { ViewDocumentModal } from '~/@biz_investor/sign-contracts/ViewDocumentModal/ViewDocumentModal'

export const DocumentsPage = () => {
  const location = useLocation()

  const { showAlert } = useAlert()
  const navigate = useNavigate()

  const [documents, setDocuments] = useState<IContractsGroup[] | null>(null)
  const [documentModal, setDocumentModal] = useState({
    isOpen: false,
    title: '',
    body: '',
  })

  const isOwnerRoute = location.pathname.includes('/vlastnik/')

  const contractMain = documents?.find((doc) => doc.type === 'investor_main') //TODO tu to upravit nech to berie aj dokumenty pre owenera
    ?.contracts?.[0]
  const contractOrders = documents?.find(
    (doc) => doc.type === 'investor_investment_order' //TODO tu to upravit nech to berie aj dokumenty pre owenera
  )?.contracts

  const closeDocumentModal = () =>
    setDocumentModal({ isOpen: false, title: '', body: '' })

  const getDocuments = async () => {
    try {
      const { data: response } =
        await getApi().investorContractsAppApiControllerGetInvestmentOrders()

      if ('success' in response) {
        setDocuments(response.contracts)
        return
      }

      throw new Error('Nastala chyba pri načítavaní investičných príležitostí.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  const downloadPdf = async (contract: IContract) => {
    try {
      const response =
        await getApi().investorContractsAppApiControllerGenerateSignaleDraftPdf(
          contract.id
        )

      const pdfData = await response.arrayBuffer()
      const blob = new Blob([pdfData], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = `${contract.type}-${contract.investmentOrderId}_contract.pdf`

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      URL.revokeObjectURL(url)

      showAlert('success', 'Sťahovannie prebehlo úspešne.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  useEffect(() => {
    getDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack className="pb-28">
      <Stack className="flex-row min-h-[70px] items-center gap-3 px-6">
        <ArrowSvg
          className="cursor-pointer"
          onClick={() =>
            navigate(
              isOwnerRoute ? '/vlastnik/user-profile' : '/investor/user-profile'
            )
          }
        />
        <Stack className="">
          <Typography className="text-base font-bold text-zBlack200">
            Moje dokumenty
          </Typography>
          <Typography className="text-xs/[14px] font-medium text-zGrey400">
            Používateľský profil
          </Typography>
        </Stack>
      </Stack>
      <Stack className="px-6 mt-6">
        {contractMain && (
          <Stack className="gap-3.5 ">
            <Typography className="text-base font-bold text-zBlack200">
              Bonaship
            </Typography>

            <Document
              title={contractMain.title}
              onClickView={() =>
                setDocumentModal({
                  isOpen: true,
                  title: contractMain.title,
                  body: contractMain.content,
                })
              }
              onClickDownload={() => downloadPdf(contractMain)}
            />
          </Stack>
        )}

        {contractOrders && contractOrders.length > 0 && (
          <Stack className="gap-3.5 mt-6">
            <Typography className="text-base font-bold text-zBlack200">
              Dokumenty k objednávkam
            </Typography>

            {contractOrders?.map((contr) => (
              <Document
                key={contr.id}
                title={contr.title}
                onClickView={() =>
                  setDocumentModal({
                    isOpen: true,
                    title: contr.title,
                    body: contr.content,
                  })
                }
                onClickDownload={() => downloadPdf(contr)}
              />
            ))}
          </Stack>
        )}
      </Stack>

      <ViewDocumentModal
        isOpen={documentModal.isOpen}
        handleClose={closeDocumentModal}
        title={documentModal.title}
        body={documentModal.body}
      />
    </Stack>
  )
}
